.modal {
    section {
        width: 36rem;
        height: 24.25rem;
        overflow: hidden;
    }
}

.input {
    background-color: var(--mantine-color-dark-5);
    font-size: var(--mantine-font-size-sm);
}

/* TODO: apply this to subtle button variant globally */
.clearButton {
    &:disabled {
        background-color: transparent;
        > span > span {
            color: var(--mantine-color-dark-3);
        }
    }
}

.successAnimation {
    width: 11.68rem;
    height: 11.68rem;
}
